import wsmLogoColor from "@assets/images/wsm-logo-color.png";
import { Box, Paragraph } from "@saleor/macaw-ui-next";
import React from "react";

export const MountingPoint = () => {
  const logo = wsmLogoColor;

  return (
    <Box display="flex" gap={3} paddingX={4} paddingY={5} alignItems="center">
      <img
        src={logo}
        width={32}
        height={32}
        style={{
          borderRadius: "50%",
        }}
      />
      <Paragraph size={4} fontWeight="bold" letterSpacing={1}>
        WEBSHOP MANAGER
      </Paragraph>
    </Box>
  );
};
